// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.display-address[data-v-504a348f]{display:inline-flex;justify-content:right}.display-address>span[data-v-504a348f]{text-align:right;display:inline-block}`, "",{"version":3,"sources":["webpack://./client/components/Display/DisplayAddress.vue"],"names":[],"mappings":"AAGA,kCACE,mBAAA,CACA,qBAAA,CAEA,uCACE,gBAAA,CACA,oBAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
